export class GoPage {

	/** @ngInject */
	constructor (private $document: ng.IDocumentService) {}

	public setTitle (title: string) {
		this.$document[0].title = title;
	}
}
